<template>
  <b-col class="animated fadeIn">
    <b-row class="justify-content-center">
      <b-col>
        <b-row class="mt-4">
          <div class="col-sm-6 col-lg-3" v-for="app in apps" :key="app.name">
            <b-link>
              <b-card :no-body="true" @click="navigate(app)">
                <div class="p-3 clearfix">
                  <i class="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"></i>
                  <div class="h5 text-info mb-0 mt-2">{{ app.name }}</div>
                  <small class="text-muted">{{ app.info }}</small>
                </div>
              </b-card>
            </b-link>
          </div>
        </b-row>
      </b-col>
    </b-row>

    <b-card no-body>
      <div slot="header"> Todo List
        <div class="card-header-actions">
          <b-row>
            <span class="pt-1 pr-2">Filter</span>
            <input type="search" style="width:200px; height:34px !important; margin-right:2px;" v-model="filter"
              placeholder="Type to Search" />
            <b-pagination v-show="(todos.items.length > 0)" align="right" style="margin-bottom: -25px !important;"
              :total-rows="todos.total" :per-page="todos.limit" v-model="todos.page"></b-pagination>
          </b-row>
        </div>
      </div>

      <!-- <div v-show="(todos.items.length>0)" style="margin-top:-21px;"> -->
      <b-table class="ml-1" ref="tblTaskTodo" responsive striped hover small style="font-size:smaller;"
        :items="todos.items" :fields="todoFields" :current-page="todos.page" :per-page="todos.limit"
        :sort-by.sync="todos.sortBy" :sort-desc.sync="todos.sortDesc" @row-clicked="selectItem" :filter="filter"
        @filtered="onFiltered" show-empty>
        <template v-slot:cell(createdate)="data">
          {{ data.item.createdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>

      </b-table>
      <!-- </div> -->
    </b-card>
    <b-card header="Activity / Agenda">

    </b-card>

  </b-col>
</template>

<style lang="scss" scoped>
.card {
  &.link {
    cursor: pointer;
    transition: all 0.4s;

    &:hover {
      background-color: #f0f3f5;
    }
  }

  .card-body {
    height: 140px;
  }
}
</style>


<script>
import toastr from "mini-toastr";
import crud from "../apis/crud";
import moment from "moment";
import auth from "../apis/auth.js";

import modules from "../apis/modules";
toastr.init();

export default {
  data() {
    return {
      interval: null,
      lastTime:moment(),
      user: this.$store.state.user,
      apps: [],
      todos: {
        items: [],
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'createdate',
        sortDesc: true,
      },
      todoFields: [
        {
          key: "taskname",
          label: "Doc./Task Name",
          sortable: true
        },
        {
          key: "taskdetail",
          label: "Doc./Task Description",
        },
        {
          key: "createby",
          label: "Created By",
          sortable: true
        },
        {
          key: "createdate",
          thStyle: "width:110px",
          label: "Created @",
          sortable: true
        },
      ],
      filter: ''
    };
  },
  computed: {
    compcode() {
      return this.$store.state.user.compcode;
    },
  },
  watch: {
    compcode: function (newval) {
      toastr.warn('Company has been changed');
      // this.refresh()
      this.TaskTodo()
    },
    // "todos.page": function(){
    //   setTimeout(() => {
    //     this.refresh()        
    //   }, 200);
    // },
  },
  created: async function () {
    // const [a,b] = await Promise.all([modules.apps(),this.TaskTodo()]) ;
    // this.apps = a;
    // this.todos.items = b;
    this.apps = await modules.apps();
    setTimeout(() => {
      this.TaskTodo()
    }, 100);
  },
  mounted() {
    this.interval = setInterval(this.getTaskTodo, 180000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  sockets: {
    task_changed: function (data) {
      console.log('socket server emit task_changed: ', data);
      // if ((data.username === this.$store.state.user.username) && (data.compcode === this.$store.state.user.compcode)) {
      // if (data.compcode === this.$store.state.user.compcode) {
      if (data.username === this.$store.state.user.username) {
        this.getTaskTodo();
      }
    },
    // notificationcounter: function () {
    //   modules.apps().then((result) =>{
    //      this.apps=result;
    //   });
    // },
    },
  methods: {
    getTaskTodo(){
      const saiki=moment();
      const diffInMinutes = saiki.diff(this.lastTime, 'minutes');
      if (diffInMinutes>2) {
        this.TaskTodo;
        this.$socket.emit('notificationupdate', {key:'notifycount', user : this.user})
      }
    },
    TaskTodo: function () {
      modules.listtodo(this.todos).then((list) => {
        this.todos.items = list;
        this.todos.total = list.length;
        this.lastTime=moment();
        // this.todos.page = 1;
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todos.total = filteredItems.length;
      this.todos.page = 1;
      if (this.todos.total == 0) {
        this.TaskTodo();
      }
    },
    async refresh(ctx) {
      // this.todos.items = await this.TaskTodo();
      this.$refs.tblTaskTodo.refresh();
    },
    async selectItem(item, index) {
      console.log('this.user.compcode',this.user.compcode)
      console.log('item', item)
      if (item.compcode) {
        if (this.user.compcode != item.compcode) {
          // lakukan Change Company
          toastr.info('Do task for Other Company, please wait');
          const baru = await crud.detail({ tablename: 'company', key: item.compcode });
          for (var key in baru) {
            this.user[key] = baru[key];
          }
          await auth.updateLastCompany(baru);
          // location.reload();
          // this.refreshCompany(baru);
        }
      }
      if (item.routeParam) {
        if (item.url) {
          const param = JSON.parse(item.routeParam);
          let str = '';
          for (const key in param) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(param[key]);
          }
          const url = `/${item.url}${str}`;
          window.open(url, "_blank");
          // window.open(url, "_self");
        } else {
          router.push({ name: item.routeName, params: JSON.parse(item.routeParam) });
        }

      } else {
        router.push({ name: item.routeName });
      }
    },
    navigate(app) {
      const { $router } = this;
      const { url } = app;

      if (url) {
        if (app.statichtml == '1') {
          location.href = url;
          // window.open(url, "_self");
        } else {
          if (url.indexOf("http") === 0) {
            window.open(url, "_blank");
          } else {
            $router.push(url);
          }
        }
      }
    }
  }
};
</script>
